<script setup>
import { computed } from 'vue';
import { resolveColourValue } from '@/Helpers/themeColourResolver';

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    brand: { type: Object, default: () => ({}) },
    shift: { type: Number, default: 0 },
});

const markerColourHex = computed(() => resolveColourValue(props.row?.content?.markerColour, props.brand, props.shift));
const markerBgHex = computed(() => resolveColourValue(props.row?.content?.markerBgColour, props.brand, props.shift));
const textColourHex = computed(() => resolveColourValue(props.row?.content?.textColour, props.brand, props.shift));

const markerSize = computed(() => props.row?.content?.markerSize || 36);
const markerStyles = computed(() => ({
    width: `${markerSize.value}px`,
    height: `${markerSize.value}px`,
    backgroundColor: markerBgHex.value,
    color: markerColourHex.value,
    fontSize: `${Math.max(10, Math.round(markerSize.value * 0.45))}px`,
}));
const markerBulletStyle = computed(() => {
    const dot = Math.max(4, Math.round(markerSize.value * 0.25));
    return {
        width: `${dot}px`,
        height: `${dot}px`,
        backgroundColor: markerColourHex.value,
    };
});
const markerIconStyle = computed(() => ({
    fontSize: `${Math.max(10, Math.round(markerSize.value * 0.5))}px`,
}));

const itemTextStyle = computed(() => {
    const content = props.row?.content || {};
    const style = {
        color: textColourHex.value,
        fontWeight: content.textBold === false ? 'normal' : 'bold',
        fontStyle: content.textItalic ? 'italic' : 'normal',
    };
    if (content.textFontSize) {
        style.fontSize = `${content.textFontSize}px`;
    }
    if (content.textFont) {
        style.fontFamily = content.textFont.replace(/_/g, ' ');
    }
    return style;
});
</script>

<template>
    <div v-if="row.content?.items" class="w-full p-fl-4">
        <div class="flex flex-col gap-4">
            <div
                v-for="(item, index) in row.content.items"
                :key="index"
                class="flex items-center gap-4"
            >
                <div
                    class="flex items-center justify-center shrink-0 rounded-full font-bold"
                    :style="markerStyles"
                >
                    <template v-if="row.content.markerStyle === 'number'">
                        {{ index + 1 }}
                    </template>
                    <template v-else-if="row.content.markerStyle === 'bullet'">
                        <span
                            class="block rounded-full"
                            :style="markerBulletStyle"
                        />
                    </template>
                    <template v-else-if="row.content.markerStyle === 'icon'">
                        <font-awesome-icon :icon="'fa-light ' + (item.icon || row.content.markerIcon)" :style="markerIconStyle" />
                    </template>
                </div>
                <span
                    :style="itemTextStyle"
                    v-text="item.text"
                />
            </div>
        </div>
    </div>
</template>
